<template>
  <div>
    <!-- Breadcrumb -->
    <app-breadcrumb>
      <template #contentright>
        <b-button variant="primary"
          v-b-modal.modalDialog>
          <span class="text-nowrap">
            <feather-icon icon="PlusCircleIcon" /> {{ $t('Add New') }} </span>
        </b-button>
      </template>
    </app-breadcrumb>
    <!-- Filters -->
    <b-row class="mb-1">
      <b-col cols="12"
        md="4"
        class="mb-md-0 mb-2">
        <b-input-group>
          <b-form-input v-model="localSearchQuery"
            class="d-inline-block"
            placeholder="Từ khóa"
            @keyup.enter="updateSearchQuery" />
          <b-input-group-append>
            <b-button variant="primary"
              @click="updateSearchQuery">
              <feather-icon icon="SearchIcon" />
            </b-button>
          </b-input-group-append>
        </b-input-group>
      </b-col>
    </b-row>
    <!-- Table Container Card -->
    <b-overlay :show="loading"
      spinner-variant="primary"
      spinner-type="grow"
      spinner-small
      rounded="sm">
      <b-card no-body
        class="mb-0">
        <b-table ref="refUserListTable"
          class="position-relative"
          :items="itemsData"
          :fields="tableColumns"
          primary-key="id"
          responsive
          show-empty
          empty-text="Không tìm thấy kết quả">
          <!-- Column: Actions -->
          <template #cell(actions)="data">
            <b-button size="sm"
              class=""
              variant="outline-primary"
              @click="edit(data.item)">
              <span class="text-nowrap">
                <feather-icon icon="EditIcon" />
              </span>
            </b-button>
            <b-button size="sm"
              class="ml-1"
              variant="outline-danger"
              @click="confirmDelete(data.item.id)">
              <span class="text-nowrap">
                <feather-icon icon="TrashIcon" />
              </span>
            </b-button>
          </template>
        </b-table>
        <div class="mx-2 mb-2">
          <b-row>
            <b-col cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-start">
              <span class="text-muted">{{ $t('show_to_entries', { from: dataMeta.from, to: dataMeta.to, of: dataMeta.of }) }}</span>
            </b-col>
            <!-- Pagination -->
            <b-col cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-end">
              <b-pagination v-model="currentPage"
                :total-rows="totalEntries"
                :per-page="perPage"
                first-number
                last-number
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item">
                <template #prev-text>
                  <feather-icon icon="ChevronLeftIcon"
                    size="18" />
                </template>
                <template #next-text>
                  <feather-icon icon="ChevronRightIcon"
                    size="18" />
                </template>
              </b-pagination>
            </b-col>
          </b-row>
        </div>
      </b-card>
    </b-overlay>
    <b-modal id="modalDialog"
      no-close-on-backdrop
      hide-footer
      @close="hidenModal"
      :title="title">
      <tags-form :dataEdit="dataEdit"
        @updateList="handleDialog" />
    </b-modal>
  </div>
</template>

<script>
import {
  BOverlay, BCard, BRow, BCol, BButton, BTable,
  BPagination, BInputGroup, BInputGroupAppend, BCardBody, BFormInput,
} from 'bootstrap-vue'
import { ref, computed, watch } from '@vue/composition-api'
import { showToast } from '@/@core/utils/utils'
import store from '@/store'
import AppBreadcrumb from '@core/layouts/components/AppBreadcrumb.vue'
import TagsForm from './TagsForm.vue'

export default {
  components: {
    AppBreadcrumb,
    BCardBody,
    BOverlay,
    BInputGroup,
    BInputGroupAppend,
    BFormInput,
    BCard,
    BRow,
    BCol,
    BButton,
    BTable,
    BPagination,
    TagsForm
  },
  data() {
    return {
      title: "Thêm mới",
      dataEdit: {},
    }
  },
  setup() {
    const loading = ref(true)
    const perPage = ref(30);
    const totalEntries = ref(0);
    const currentPage = ref(1);
    const localSearchQuery = ref('')
    const searchQuery = ref('');
    const refListTable = ref(null);
    const itemsData = ref([])
    const total = ref(0)
    const tableColumns = [
      { key: 'id', sortable: false, thAttr: { width: '50' } },
      {
        key: 'name',
        sortable: false,
        label: 'Thẻ tag',
        thAttr: {},
      },
      {
        key: 'actions',
        sortable: false,
        label: 'Hành động',
        thAttr: { width: '200' },
        thClass: 'text-right',
        tdClass: 'text-right',
      },
    ];

    const dataMeta = computed(() => {
      const localItemsCount = refListTable.value ? refListTable.value.localItems.length : 0;
      return {
        from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
        to: perPage.value * (currentPage.value - 1) + localItemsCount,
        of: totalEntries.value,
      };
    });
    const fetchTags = () => {
      store
        .dispatch('tags/fetchTags', {
          keyword: searchQuery.value,
          perPage: perPage.value,
          page: currentPage.value,
        })
        .then((response) => {
          loading.value = false;
          let result = response.data
          if (result.code === 200) {
            itemsData.value = result.data.data;
            total.value = result.data.total;
          }
        });
    };

    const refetchData = () => {
      fetchTags();
    };

    watch([currentPage, perPage, searchQuery], () => {
      refetchData();
    });
    fetchTags();


    const updateSearchQuery = () => {
      searchQuery.value = localSearchQuery.value
    }

    return {
      loading,
      tableColumns,
      perPage,
      currentPage,
      totalEntries,
      dataMeta,
      searchQuery,
      itemsData,
      localSearchQuery,
      tableColumns,
      refetchData,
      updateSearchQuery
    }
  },
  methods: {
    hidenModal() {
      this.$bvModal.hide('modalDialog');
      this.dataEdit = {};
    },
    handleDialog() {
      this.$bvModal.hide('modalDialog');
      this.refetchData();
    },
    edit(item) {
      this.dataEdit = item;
      this.title = 'Cập nhật';
      this.$bvModal.show('modalDialog');
    },
    confirmDelete(id) {
      this.$swal({
        text: 'Bạn chắc muốn xóa từ khóa này không?',
        showCancelButton: true,
        confirmButtonText: 'Có',
        cancelButtonText: 'Không',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          this.$store.dispatch('tags/deleteTag', { id }).then((res) => {
            if (res.status === 200) {
              this.refetchData();
              showToast(res.data.message, { variant: 'success' });
            } else {
              showToast(res.data.message);
            }
          })
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
